import parseBirthdayFromInput from '@/helpers/parse-birthday-from-input';


function configureFullName(fullName) {
  const [firstName, ...rest] = fullName.trim().split(' ');

  return {
    firstName,
    lastName: rest.join(' ')
  };
}

export default function configureProfileInfo(details) {
  const { dateOfBirth = null, fullName = null, primarySmsNumber = null, inviteCode = null, ...rest } = details;

  const userProfile = {
    ...rest
  };

  if ('dateOfBirth' in details) {
    const birthdayInfo = dateOfBirth ? parseBirthdayFromInput(dateOfBirth) : null;

    Object.assign(userProfile, { birthdayInfo });
  }

  if ('fullName' in details) {
    const nameDetails = fullName ? configureFullName(fullName) : { firstName: '', lastName: '' };

    Object.assign(userProfile, { ...nameDetails });
  }

  if (primarySmsNumber) {
    /*
      Preserve a leading '+' so the BE receives canonical E.164 (per the
      international-phone requirement). Strip any other non-digit characters
      defensively in case a legacy caller passes a formatted string like
      "(415) 555-5510" — that becomes "4155555510" rather than "+1..." to
      avoid inventing a country code we don't know.
    */
    Object.assign(userProfile, { primarySmsNumber: primarySmsNumber.replace(/[^0-9+]/g, '') });
  }

  if (inviteCode) {
    Object.assign(userProfile, { referredByCode: inviteCode.toUpperCase() });
  }

  return userProfile;
}

